"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.EmptyBanner = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Link = require("@fluentui/react/lib/Link");

var React = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _EmptyBanner = require("./EmptyBanner.types");

var _dec, _class;

var bannerStyles = require('../../styling/patterns/Banner.scoped.scss');
/**
 * Represents an empty banner with optional action.
 */


var EmptyBanner = (_dec = (0, _reactI18next.translate)('App'), _dec(_class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EmptyBanner, _React$Component);

  var _super = (0, _createSuper2.default)(EmptyBanner);

  function EmptyBanner() {
    (0, _classCallCheck2.default)(this, EmptyBanner);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(EmptyBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          onAction = _this$props.onAction,
          actionText = _this$props.actionText,
          actionLabel = _this$props.actionLabel,
          t = _this$props.t;
      var message;

      if (typeof text === 'string') {
        // Text is already a localized text
        message = text;
      } else if (text) {
        message = t === null || t === void 0 ? void 0 : t(text.key, text.options);
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        role: "alert",
        "aria-labelledby": "ms-banner",
        className: (0, _react.css)('ms-Empty', bannerStyles.fullPage),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _EmptyBanner.emptyImage,
          className: bannerStyles.image,
          "aria-hidden": true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          id: "ms-banner",
          className: (0, _react.css)('ms-banner-text', bannerStyles.text),
          children: message || (t === null || t === void 0 ? void 0 : t('noItemsMessage'))
        }), onAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
          onClick: onAction,
          "aria-label": actionLabel,
          children: actionText
        }) : null]
      });
    }
  }]);
  return EmptyBanner;
}(React.Component)) || _class);
exports.EmptyBanner = EmptyBanner;